export enum SectionType {
    Body = 1,
    ProjectSpecific = 2,
    StandAlone = 3,
    Signature = 4
}
